import React from 'react';
import { motion } from 'framer-motion';
export function StepsSection() {
  const steps = [{
    num: '1',
    title: 'Elige UNA acción',
    desc: 'Una acción diaria pequeña (1–5 min) que no requiera esfuerzo.'
  }, {
    num: '2',
    title: 'Reemplaza el detonador',
    desc: 'Cambia tu mayor detonador con un ritual corto y consciente.'
  }, {
    num: '3',
    title: 'Registra el logro',
    desc: 'Márcalo cada día. Construye evidencia de tu nueva identidad.'
  }, {
    num: '4',
    title: 'Revisa y ajusta',
    desc: 'Revisa semanalmente, ajusta lo necesario y repite el proceso.'
  }];
  return <section className="bg-dark-alt py-24" data-id="element-119">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} data-id="element-121">
          <h2 className="font-display text-3xl md:text-5xl font-bold text-center mb-16 uppercase" data-id="element-122">
            El sistema en 4 pasos simples
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-123">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="relative flex flex-col items-center text-center" data-id="element-124">
                <div className="w-16 h-16 rounded-full bg-accent text-white font-display font-bold text-3xl flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(255,77,26,0.4)] z-10" data-id="element-125">
                  {step.num}
                </div>
                {index !== steps.length - 1 && <div className="hidden lg:block absolute top-8 left-[60%] w-[80%] h-[2px] bg-dark-border -z-0" data-id="element-126"></div>}
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-127">
                  {step.title}
                </h3>
                <p className="text-gray-400" data-id="element-128">{step.desc}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}